import * as React from 'react';
import { ReferralHero } from '../../../components/ReferralHero';
import { Modal } from '@cian/ui-kit';
import { ModalFormContainer } from '../Form';
import { useToggleStickyScrollBtn } from '../../../hooks/useToggleStickyScrollBtn';
import { useDispatch, useSelector } from 'react-redux';
import { setReferralModalFormClose, setReferralModalFormOpen } from '../../../slices';
import { selectIsReferralModalOpen } from '../../../selectors';
import { trackGetConsultationClick } from './tracking';

export const HeroContainer: React.FC = () => {
  const isModalOpen = useSelector(selectIsReferralModalOpen);

  const dispatch = useDispatch();
  const stickyRef = React.useRef<HTMLDivElement>(null);

  useToggleStickyScrollBtn(stickyRef);

  const handleModalOpenClick = React.useCallback(() => {
    trackGetConsultationClick();
    dispatch(setReferralModalFormOpen('consultation'));
  }, [dispatch]);

  const handleModalCloseClick = React.useCallback(() => {
    dispatch(setReferralModalFormClose());
  }, [dispatch]);

  return (
    <>
      <ReferralHero stickyRef={stickyRef} onClick={handleModalOpenClick} />

      <Modal header={<div />} open={isModalOpen} onOpenChange={handleModalCloseClick} size="S">
        <ModalFormContainer />
      </Modal>
    </>
  );
};
